export const default_stock = {
    is_in_stock: false,
    qty: 0
};
